import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/GoToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionProvider"] */ "/home/ubuntu/Nippon/frontend/src/components/providers/motion-provider.tsx");
